export const DEFAULT_PROTECTED_ZONE_RANGE_M = 50;
export const PROTECTED_ZONE_RANGE_MIN_M = 1;
export const PROTECTED_ZONE_RANGE_MAX_M = 10000;
